type AssetImageScope = {
  orgId?: string;
  tenantId?: string;
};

const ASSET_SCOPE_KEY = "__SALIFY_ASSET_SCOPE__";

/** Server + client: parent layout sets scope before children so `toAssetImages` sees org/tenant on SSR. */
export function setClientAssetImageScope(scope: AssetImageScope) {
  const orgId = scope.orgId?.trim();
  const tenantId = scope.tenantId?.trim();
  (globalThis as any)[ASSET_SCOPE_KEY] = {
    ...(orgId ? { orgId } : {}),
    ...(tenantId ? { tenantId } : {}),
  };
}

export function getClientAssetImageScope(): AssetImageScope | null {
  const scope = (globalThis as any)[ASSET_SCOPE_KEY] as AssetImageScope | undefined;
  if (!scope?.orgId || !scope?.tenantId) return null;
  return { orgId: scope.orgId, tenantId: scope.tenantId };
}
